import {Part} from "../part";
import {wallsThumbnail} from "../../../bvComponent/core/assets";
import {PartMenuType} from "../../../visComponents/constants";

import Decor from "../subparts/globals/decor";
import {DECORS_MAX} from "../constants";
import Basket from "../subparts/globals/basket";

const compareMountPosition = (checkFeature, dbFeatureLoading) => {
  return checkFeature.metaData["MountPosition"] && checkFeature.matchesMetaForCondition("MountPosition", dbFeatureLoading.metaData["MountPosition"])
}

const checkForExistingDecor = (currentDecorFeatureGroup, dbFeature) => {
  if (!currentDecorFeatureGroup) { // we skipped all decors, but didn't find the same
    return true
  }
  if (dbFeature.sharedFeatureName === currentDecorFeatureGroup.decorName) { // decors are matching by name
    return true
  }
  if (dbFeature.metaData["MountPosition"]) {
    if (Array.isArray(dbFeature.metaData["RoomLayout"])) {
      return dbFeature.metaData["RoomLayout"].some(layoutName => {
        return currentDecorFeatureGroup.featuresList && Array.isArray(currentDecorFeatureGroup.featuresList[layoutName])
          && currentDecorFeatureGroup.featuresList[layoutName].some(feature => compareMountPosition(feature, dbFeature))
      })
    } else {
      return currentDecorFeatureGroup.some(feature => compareMountPosition(feature, dbFeature))
    }
  }
  return false
}

export default class Globals extends Part {
  static id = "Globals";
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = "Globals";
    this.partThumbnail = wallsThumbnail;

    // related items
    this.decor1 = null; // can be up to 10
    this.basket = null; // can be up to 10
  }

  load(dbFeature) {
    let
      relatedItemName = "",
      decorCount = 0,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Decor":
      case "Decore": {
        for (let i = 1; i <= DECORS_MAX; i++) {
          const currentDecorFeatureGroup = this["decor" + i];
          if (checkForExistingDecor(currentDecorFeatureGroup, dbFeature)) {
            relatedItemName = "decor" + i;
            decorCount = i;
            break;
          }
        }
        break;
      }
      // case "Attachment": {
      //   relatedItemName = "attachment";
      //   RelatedItemClass = Attachment;
      //   break;
      // }
      case "Basket": {
        relatedItemName = "basket";
        RelatedItemClass = Basket;
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        if (dbFeature.groupName === "Decor" || dbFeature.groupName === "Decore") {
          this[relatedItemName] = new Decor(true, decorCount);
          this[relatedItemName].decorName = dbFeature.sharedFeatureName;
        } else {
          this[relatedItemName] = new RelatedItemClass(true);
        }
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {}

}
